import React, { useState } from "react";
import "../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ReLoginModal from "./ReLoginModal";
import api from "../util/axios";

const RejectRequisition = ({
  details,
  setRejectModal,
  handleRejectModal,
}: any) => {
  const navigate = useNavigate();
  const token = window.localStorage.getItem("token");
  const [sign, setSign] = useState({
    remark: "",
    status: "",
  });
  const [loading, setLoading] = useState(false);
  const [reLogin, setReLogin] = useState(false);

  const handleChanges = ({ target: { name, value } }: any) => {
    setSign((prevSign) => ({
      ...prevSign,
      [name]: value,
    }));
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault();

    api
      .patch(
        `/requisition/${details._id}`,
        {
          status: "REJECTED",
          remark: sign.remark,
        },
        { headers: headers }
      )
      .then((res) => {
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          // cancelButtonColor: "red",
          confirmButtonText: "Continue",
          // cancelButtonText: "Leave Page",
        });
        setLoading(false);
        setRejectModal(false);
        setTimeout(() => {
          navigate("/dashboard/approval");
        }, 4000);
      })
      .catch((err) => {
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          // cancelButtonColor: "red",
          confirmButtonText: "Try Again",
          // cancelButtonText: "Leave Page",
        });
        setLoading(false);
      });
  };

  return (
    <div className="modal">
      {reLogin ? <ReLoginModal /> : null}
      <form onSubmit={handleSubmit} className="catModal">
        <div className="catModalTop">
          <h4>Reject</h4>
          <ImCancelCircle className="catCancel" onClick={handleRejectModal} />
        </div>
        <div className="line"></div>

        <div className="catModalInput branchInput">
          <textarea
            placeholder="Remarks"
            name="remark"
            value={sign.remark}
            onChange={handleChanges}
          ></textarea>
        </div>

        <div className="catModalBtn">
          <button
            type="submit"
            className="catBtn1"
            style={{ color: "#fff", backgroundColor: "#FF0303" }}
          >
            {loading ? (
              <CircularProgress
                style={{
                  color: "#fff",
                  backgroundColor: "transparent",
                  width: "20px",
                  height: "20px",
                }}
              />
            ) : (
              "Reject"
            )}
          </button>
          <button className="catBtn2" onClick={handleRejectModal}>
            Back
          </button>
        </div>
      </form>
    </div>
  );
};

export default RejectRequisition;
